import React from "react";
import NamedResourceList from "../curriculum/components/named-resource-list";
import {cvPositionService} from "../../services/curriculum-resource-service";

const columns = [
    {field: "name", headerName: "Nome", flex: 1},
];

const CvPosition = () => (
    <NamedResourceList title="Cargos" newLabel="Novo cargo" basePath="/cv/position"
                       queryKey="cv-positions" service={cvPositionService} columns={columns}/>
);

export default CvPosition;
